import React, { useEffect, useState, useMemo } from "react";
import "./ReconciledReport.css";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from "../operator_home/sidebar/Sidebar";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import GetAppIcon from "@material-ui/icons/GetApp";
import UndoIcon from "@material-ui/icons/Undo";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";
import ReconciledReportView from "./ReconciledReportView";
import { getErrorToast, getSuccessToast } from "../../toast";
import { useNavigate } from "react-router-dom";
var fileDownload = require("js-file-download");

function ReconciledReport() {
  const [reconciledData, setreconciledData] = useState([]);
  const [legendDisplay, setLegendDisplay] = useState(false);
  const [undoDisabled, setUndoDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const box_id = ReactSession.get("box_id");
  const role = ReactSession.get("role");
  const isAdmin = role === "1" || role === 1;
  const readOnly = false; // Glenmark doesn't have admin read-only mode yet

  const columns = [
    {
      id: "Sr_no",
      width: "5%",
      label: "SR NO",
    },
    {
      id: "Material_name",
      width: "20%",
      label: "MEDICINE NAME (Claim)",
    },
    {
      id: "batch_no",
      width: "15%",
      label: "BATCH NO (Claim)",
    },
    {
      id: "quantity",
      width: "10%",
      label: "CLAIMED QTY",
    },
    {
      id: "quantity2",
      width: "10%",
      label: "SCANNED QTY",
    },
    {
      id: "short",
      width: "8%",
      label: "SHORT",
    },
    {
      id: "excess",
      width: "8%",
      label: "EXCESS",
    },
    {
      id: "status",
      width: "10%",
      label: "STATUS",
    },
    {
      id: "remark",
      width: "8%",
      label: "REMARK",
    },
    {
      id: "dropdown",
      width: "6%",
      label: "ACTION",
    },
  ];

  // Calculate stats
  const stats = useMemo(() => {
    const total = reconciledData.length;
    const short = reconciledData.filter(item => item.Type === "short").length;
    const excess = reconciledData.filter(item => item.Type === "excess").length;
    const equal = reconciledData.filter(item => item.Type === "equal").length;
    return { total, short, excess, equal };
  }, [reconciledData]);

  const downloadCsv = async () => {
    const partyINFO = await axiosPrivate.get(
      `/data_entry/party-info/${box_id}/`
    );
    axiosPrivate
      .post(
        `reconcilation/downlaod-reconciliation-report/${box_id}`,
        reconciledData,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        let name = `${partyINFO.data["party_name"]}_${partyINFO.data["party_code"]}_${partyINFO.data["lr_number"]}.xlsx`;
        fileDownload(response.data, name);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const claimInfo = () => {
    const id = ReactSession.get("box_id");
    axiosPrivate
      .get(`reconcilation/reconcile/${id}`)
      .then((res) => {
        setreconciledData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    claimInfo();
  }, []);

  const updateHandler = (event, inner_row_index, object) => {
    const data = object[inner_row_index];
    if (
      data["quantity"] === "" ||
      data["quantity"] === null ||
      data["quantity"] === undefined
    ) {
      getErrorToast("quantity can not be empty".toUpperCase());
      return;
    }
    if (data["quantity"] === "0" || data["quantity"] === 0) {
      getErrorToast("quantity can not be Zero".toUpperCase());
      return;
    }
    if (data["quantity"] <= "0" || data["quantity"] <= 0) {
      getErrorToast("quantity can not be negative".toUpperCase());
      return;
    }
    if (
      data["medicine_batch"] === "" ||
      data["medicine_batch"] === null ||
      data["medicine_batch"] === undefined
    ) {
      getErrorToast("BATCH NUMBER can not be empty".toUpperCase());
      return;
    }

    axiosPrivate
      .patch(`reconcilation/reconcile/${ReactSession.get("box_id")}`, data)
      .then((res) => {
        if (res.status === 204) {
          getSuccessToast("Record updated successfully.");
          claimInfo();
        }
      });
  };

  const UndoAPI = () => {
    setUndoDisabled(true);
    const data = {
      status: false,
    };
    axiosPrivate
      .patch(
        `reconcilation/save-reconciliation/${ReactSession.get("box_id")}/`,
        data
      )
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          getSuccessToast("Reconciliation Undo.");
          navigate("/stockist-report");
        }
      })
      .catch((error) => {
        console.log(error);
        getErrorToast("Something went wrong!");
      })
      .finally(() => {
        setUndoDisabled(false);
      });
  };

  useEffect(() => {
    document.body.classList.add('reconciled-report-page');
    return () => {
      document.body.classList.remove('reconciled-report-page');
    };
  }, []);

  return (
    <section className="reconciled-report-main">
      <Header />
      {role === '2' ? (
        <Sidebar className="sidebar-operator-home" />
      ) : (
        <OtherSidebar className="sidebar-operator-home" />
      )}
      
      <section className="reconciled-report-body">
        {/* Page Header */}
        <div className="reconciled-report-header">
          <h1 className="reconciled-report-title">
            Reconciliation Report
          </h1>
          <div className="reconciled-report-actions">
            {readOnly ? (
              <div style={{ 
                padding: '8px 16px',
                color: '#666',
                fontSize: '0.9rem',
                fontStyle: 'italic'
              }}>
                Read-only mode (Admin View)
              </div>
            ) : (
              <>
                <Tooltip title="Undo reconciliation and return to stockist report" arrow>
                  <button
                    className="reconciled-report-btn reconciled-report-btn-secondary"
                    onClick={UndoAPI}
                    disabled={undoDisabled}
                  >
                    <UndoIcon style={{ fontSize: '1.1rem' }} />
                    <span>Undo</span>
                  </button>
                </Tooltip>
              </>
            )}
            <Tooltip title="Download reconciliation report as Excel" arrow>
              <button
                className="reconciled-report-btn reconciled-report-btn-primary"
                onClick={downloadCsv}
              >
                <GetAppIcon style={{ fontSize: '1.1rem' }} />
                <span>Download</span>
              </button>
            </Tooltip>
          </div>
        </div>

        {/* Stats Bar - Compact Single Line */}
        <div className="reconciled-report-stats">
          <span className="reconciled-stat-compact">
            <strong>Total:</strong> {stats.total}
          </span>
          <span className="reconciled-stat-compact reconciled-stat-compact-short">
            <strong>Short:</strong> {stats.short}
          </span>
          <span className="reconciled-stat-compact reconciled-stat-compact-excess">
            <strong>Excess:</strong> {stats.excess}
          </span>
          <span className="reconciled-stat-compact reconciled-stat-compact-equal">
            <strong>Equal:</strong> {stats.equal}
          </span>
          <div className="reconciled-legend-wrapper">
            <button
              className="reconciled-legend-btn"
              onMouseEnter={() => setLegendDisplay(true)}
              onMouseLeave={() => setLegendDisplay(false)}
            >
              Legend
            </button>
            {legendDisplay && (
              <div className="reconciled-legend-popup">
                <div className="reconciled-legend-item">
                  <span className="reconciled-legend-color reconciled-legend-short"></span>
                  <span>Short</span>
                </div>
                <div className="reconciled-legend-item">
                  <span className="reconciled-legend-color reconciled-legend-excess"></span>
                  <span>Excess</span>
                </div>
                <div className="reconciled-legend-item">
                  <span className="reconciled-legend-color reconciled-legend-equal"></span>
                  <span>Equal</span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Table Container */}
        <div className="reconciled-report-table-container">
          <Paper className="reconciled-report-paper" elevation={2}>
            <TableContainer className="reconciled-report-table-wrapper">
              <Table stickyHeader aria-label="reconciliation table" className="reconciled-report-table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        className="reconciled-report-header-cell"
                        style={{ width: column.width }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reconciledData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} className="reconciled-report-empty-cell">
                        <div className="reconciled-report-empty">
                          <span className="reconciled-report-empty-icon">📊</span>
                          <p>No reconciliation data available</p>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    reconciledData.map((ent, idx) => (
                      <ReconciledReportView
                        key={idx}
                        updateEvent={updateHandler}
                        ent={ent}
                        id={idx}
                        readOnly={readOnly}
                      />
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </section>
    </section>
  );
}

export default ReconciledReport;
